import React from "react";
import Logo from "../images/LogoBig.png";
import logotxt from "../images/logotxt.png";
import Wave from "react-wavify";

const guidelinesData = {
  "guidelines": [
    {
      "category": "USER GUIDELINES FOR CLOGGED DRAINS",
      "steps": [
        "Avoid Direct Contact: Do not attempt to clear the clogged drain manually.",
        "Report to Jal-Suraksha: Report the clogged drain to Jal-Suraksha.",
        "Emergency Contacts: Keep emergency contact numbers readily available.",
        "Do Not Dispose of Waste: Refrain from disposing of waste into drains.",
        "Clear Debris: If safe, clear visible debris or litter around the drain entrance.",
        "Avoid Harsh Chemicals: Refrain from using harsh chemicals to unclog drains.",
        "Participate in Community Clean-Up: Join local community clean-up efforts.",
        "Educate Others: Raise awareness in the community about the importance of proper waste disposal.",
        "Follow Local Guidelines: Adhere to local guidelines and regulations.",
        "Use Drain Strainers: Install drain strainers in sinks and showers.",
        "Maintain Green Spaces: Contribute to the maintenance of green spaces.",
        "Storm Drain Awareness: Be aware of storm drains and their purpose.",
        "Promote Responsible Behavior: Encourage responsible behavior in the community."
      ]
    }
  ]
};

const FixedBottomAnimation = () => (
  <div className="absolute bottom-0 left-0 right-0">
    <Wave
      mask="url(#mask)"
      fill="#49B5F0"
      options={{
        height: 10,
        amplitude: 24,
        speed: 0.3,
        points: 3,
      }}
    >
      <defs>
        <linearGradient id="gradient" gradientTransform="rotate(90)">
          <stop offset="0" stopColor="white" />
          <stop offset="0.5" stopColor="black" />
        </linearGradient>
      </defs>
    </Wave>
  </div>
);

const DrainClog = () => {
  return (
    <div className="relative bg-white overflow-y-auto pb-20">
      <div className="w-full text-center">
        <div className="mb-2 mx-auto md:w-[7.5%] md:h-[7.5%] w-[15%] h-[15%] mt-0">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/b/b1/Ministry_of_Jal_Shakti.svg"
            alt=""
          />
        </div>
        <div className="mb-2 mx-auto md:w-[2%] w-[4%] mt-0">
          <img
            src={Logo}
            alt=""
            className="w-full mx-auto my-auto"
          />
        </div>
        <div className="mb-2 mx-auto md:w-[10%] w-[20%] mt-2">
          <img
            src={logotxt}
            alt=""
            className="w-full mx-auto my-auto"
          />
        </div>
        <div className="p-6 bg-white text-black rounded border border-gray-800">
          <h1 className="text-3xl font-bold mb-4 text-center border-b border-black pt-2">{guidelinesData.guidelines[0].category}</h1>
          <div className="text-left text-xl">
            <ul className="list-disc list-inside">
              {guidelinesData.guidelines[0].steps.map((step, index) => (
                <li key={index}>{step}</li>
              ))}
            </ul>
          </div>
          <div className="p-10"></div>
        </div>
      </div>
      <FixedBottomAnimation />
    </div>
  );
};

export default DrainClog;
